import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "who-maintains-this"
    }}>{`Who maintains this?`}</h3>
    <p>{`This is maintained by PostHog. If you have issues with it not functioning as intended, please `}<a parentName="p" {...{
        "href": "https://us.posthog.com/#panel=support%3Asupport%3Aapps%3A%3Atrue"
      }}>{`let us know`}</a>{`!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      